/* eslint-disable @typescript-eslint/no-explicit-any */
import { types, Instance, flow } from 'mobx-state-tree';
import { AxiosResponse } from 'axios';
import axios from 'server';
import { InviteModel, IInviteModel, PasswordModel, IPasswordModel } from './models/invite.model';
import { toFormatDateTime } from 'utils';

const { model, string, array } = types;

export const InviteTableStore = model('InviteTableStore', {
  invite: array(InviteModel),
  password: array(PasswordModel),
  filter: string,
})
  .views((self) => ({
    get inviteView() {
      if (!self.filter) {
        return self.invite;
      }
      const regexp = new RegExp(self.filter, 'i');
      const filteredData = self.invite.filter(({ email, created_at, updated_at }) =>
        regexp.test(`${email}${toFormatDateTime(created_at)}${toFormatDateTime(updated_at)}`)
      );
      return filteredData;
    },
    get passwordView() {
      if (!self.filter) {
        return self.password;
      }
      const regexp = new RegExp(self.filter, 'i');
      const filteredData = self.password.filter(({ email, created_at, updated_at }) =>
        regexp.test(`${email}${toFormatDateTime(created_at)}${toFormatDateTime(updated_at)}`)
      );
      return filteredData;
    },
  }))

  .volatile(() => ({}))
  .actions((self) => ({
    normalizeEmail({ data }: AxiosResponse): IInviteModel[] {
      self.invite.replace(data.data.emailStatus);
      return self.invite;
    },
    normalizePassword({ data }: AxiosResponse): IPasswordModel[] {
      self.password.replace(data.data.passwordStatus);
      return self.password;
    },
    setFilter(filter: string) {
      self.filter = filter;
    },
  }))
  .actions((self) => ({
    getInviteEmail: flow(function* () {
      const result = yield axios
        .get<IInviteModel[]>('invitations/email-status')
        .then(self.normalizeEmail)
        .catch((error) => {
          throw new Error(error.response.data.data.message);
        });
      return result;
    }),
    getInvitePassword: flow(function* () {
      const result = yield axios
        .get<IPasswordModel[]>('invitations/email-status')
        .then(self.normalizePassword)
        .catch((error) => {
          throw new Error(error.response.data.data.message);
        });
      return result;
    }),
  }));

export type IInviteTableStore = Instance<typeof InviteTableStore>;
